var map = {
	"./da/americanFootball.json": "0nxj",
	"./da/authentication.json": "Iv+7",
	"./da/common.json": "Bg0C",
	"./da/competitions.json": "/sj0",
	"./da/contests.json": "iTMj",
	"./da/cycling.json": "xXYy",
	"./da/golf.json": "12zR",
	"./da/groups.json": "UgSZ",
	"./da/handball.json": "PT1N",
	"./da/hockey.json": "gy5u",
	"./da/messageboard.json": "w9di",
	"./da/motorsport.json": "JnEA",
	"./da/no_filename.json": "FARf",
	"./da/notifications.json": "494f",
	"./da/soccer.json": "nDX0",
	"./da/stock.json": "Y3+f",
	"./da/time.json": "psGp",
	"./en/americanFootball.json": "Mfhb",
	"./en/authentication.json": "No0+",
	"./en/common.json": "/tSU",
	"./en/competitions.json": "BA8W",
	"./en/contests.json": "oeF8",
	"./en/cycling.json": "ibXe",
	"./en/golf.json": "gZR0",
	"./en/groups.json": "0pag",
	"./en/handball.json": "TP/t",
	"./en/hockey.json": "ErcJ",
	"./en/messageboard.json": "re76",
	"./en/motorsport.json": "c9aP",
	"./en/no_filename.json": "+Iw8",
	"./en/notifications.json": "u6f8",
	"./en/soccer.json": "gUWS",
	"./en/stock.json": "u8kE",
	"./en/time.json": "Sqhm",
	"./sv/americanFootball.json": "eElT",
	"./sv/authentication.json": "YRM0",
	"./sv/common.json": "bd4G",
	"./sv/competitions.json": "6I7m",
	"./sv/contests.json": "Zx2P",
	"./sv/cycling.json": "hWgL",
	"./sv/golf.json": "ZQel",
	"./sv/groups.json": "9vES",
	"./sv/handball.json": "IY1R",
	"./sv/hockey.json": "qFxS",
	"./sv/messageboard.json": "lRfz",
	"./sv/motorsport.json": "QRBB",
	"./sv/no_filename.json": "3pfi",
	"./sv/notifications.json": "kAx/",
	"./sv/soccer.json": "p04B",
	"./sv/stock.json": "ed3R",
	"./sv/time.json": "ao6f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JsoJ";